import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { SiteReleaseStore } from '@seedlang/stores';
import InPlaceText from 'components/form/in_place_text';
import InPlaceCheckbox from 'components/form/in_place_checkbox';
import autobind from 'autobind-decorator';
import { Link } from 'react-router';
import Grid from 'components/layout/grid';
import GrayButton from 'components/button/gray_button';

const Wrapper = styled.div`

`;

@observer
class SiteReleaseEdit extends React.Component {

  constructor(props) {
    super(props);
    this.getSiteRelease();
  }

  @autobind createForumThread() {
    SiteReleaseStore.createForumThread({ids: {siteReleaseId: this.props.params.siteReleaseId}}, this.getSiteRelease);
  }

  @autobind getSiteRelease() {
    SiteReleaseStore.getShow({ids: {siteReleaseId: this.props.params.siteReleaseId}}, this.afterGetShow);
  }

  @autobind afterGetShow(resp) {
    SiteReleaseStore.setShowData(resp);
  }

  render() {
    return (
      <Wrapper>
        {
          SiteReleaseStore.hasShowData &&
            <div>
              <Grid columns={3} gap='sm'>
                <InPlaceText
                  legend='Version'
                  id={SiteReleaseStore.showData.id}
                  defaultValue={SiteReleaseStore.showData.version}
                  model='site_releases'
                  field='version'
                />
                <InPlaceCheckbox
                  legend='Published'
                  id={SiteReleaseStore.showData.id}
                  defaultValue={SiteReleaseStore.showData.published}
                  model='site_releases'
                  field='published'
                />
                <InPlaceText
                  legend='Title'
                  id={SiteReleaseStore.showData.id}
                  defaultValue={SiteReleaseStore.showData.title}
                  model='site_releases'
                  field='title'
                />
              </Grid>
              <fieldset>
                <legend>Forum Thread</legend>
                {
                  SiteReleaseStore.showData.forumThreadId &&
                    <Link
                      to={{name: 'forums.forum_threads.show', params: {forumId: '9332f9ec-35ac-453d-aab3-fec5d814e300', forumThreadId: SiteReleaseStore.showData.forumThreadId}}}
                    >
                      Go to Forum Thread
                    </Link>
                }
                {
                  !SiteReleaseStore.showData.forumThreadId &&
                    <GrayButton onClick={this.createForumThread}>
                      <i className='fa fa-plus' />
                      Create Forum Thread
                    </GrayButton>
                }
              </fieldset>
            </div>
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(SiteReleaseEdit);
